var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("SModalCentered", {
        attrs: {
          title: _vm.$t("stemdoerDetail.experienceModal.title"),
          isOpen: _vm.isOpen,
          closeModal: _vm.closeModal,
          customProps: { bodyPaddingY: 0, fullWidthFooter: true },
          persistent: true,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("span", {
                    staticClass: "text-body-1 text--text text--base mb-4",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("stemdoerDetail.experienceModal.subtitle")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("SInputText", {
                        attrs: {
                          label: _vm
                            .$t("stemdoerDetail.experienceModal.position")
                            .toString(),
                          placeholder: "DevOps Engineer",
                          errorMessage:
                            _vm.vuelidate.position.$error &&
                            _vm.vuelidate.position.required?.$invalid
                              ? _vm.$t("formMessage.required").toString()
                              : undefined,
                        },
                        model: {
                          value: _vm.experienceForm.position,
                          callback: function ($$v) {
                            _vm.$set(_vm.experienceForm, "position", $$v)
                          },
                          expression: "experienceForm.position",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("SInputText", {
                        attrs: {
                          label: _vm
                            .$t("stemdoerDetail.experienceModal.company")
                            .toString(),
                          placeholder: "Stemdo",
                          errorMessage:
                            _vm.vuelidate.company.$error &&
                            _vm.vuelidate.company.required?.$invalid
                              ? _vm.$t("formMessage.required").toString()
                              : undefined,
                        },
                        model: {
                          value: _vm.experienceForm.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.experienceForm, "company", $$v)
                          },
                          expression: "experienceForm.company",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("SInputText", {
                        attrs: {
                          label: _vm
                            .$t("stemdoerDetail.experienceModal.sector")
                            .toString(),
                          placeholder: "Banking",
                          errorMessage:
                            _vm.vuelidate.sector.$error &&
                            _vm.vuelidate.sector.required?.$invalid
                              ? _vm.$t("formMessage.required").toString()
                              : undefined,
                        },
                        model: {
                          value: _vm.experienceForm.sector,
                          callback: function ($$v) {
                            _vm.$set(_vm.experienceForm, "sector", $$v)
                          },
                          expression: "experienceForm.sector",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-row mb-4",
                      staticStyle: { gap: "16px" },
                    },
                    [
                      _c("SInputDate", {
                        attrs: {
                          label: _vm
                            .$t("stemdoerDetail.experienceModal.startDate")
                            .toString(),
                          placeholder: _vm
                            .$t(
                              "stemdoerDetail.experienceModal.startDatePlaceholder"
                            )
                            .toString(),
                          errorMessage:
                            _vm.vuelidate.startDate.$error &&
                            _vm.vuelidate.startDate.required?.$invalid
                              ? _vm.$t("formMessage.required").toString()
                              : undefined,
                        },
                        model: {
                          value: _vm.experienceForm.startDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.experienceForm, "startDate", $$v)
                          },
                          expression: "experienceForm.startDate",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "position-relative w-100" },
                        [
                          _c("SInputDate", {
                            staticClass: "flex-grow-1",
                            attrs: {
                              label: _vm
                                .$t("stemdoerDetail.experienceModal.endDate")
                                .toString(),
                              placeholder: _vm
                                .$t(
                                  "stemdoerDetail.experienceModal.endDatePlaceholder"
                                )
                                .toString(),
                              errorMessage: undefined,
                            },
                            model: {
                              value: _vm.experienceForm.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.experienceForm, "endDate", $$v)
                              },
                              expression: "experienceForm.endDate",
                            },
                          }),
                          _vm._v(" "),
                          _vm.experienceForm.endDate
                            ? _c("div", {
                                staticClass:
                                  "delete-trash delete-trash-absolute pb-4",
                                on: {
                                  click: function ($event) {
                                    _vm.experienceForm.endDate = ""
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("SAutocompleteMultiple", {
                        ref: "autocompleteRef",
                        attrs: {
                          value: _vm.experienceForm.competencies,
                          placeholder: _vm
                            .$t(
                              "stemdoerDetail.experienceModal.competenciesPlaceholder"
                            )
                            .toString(),
                          items: _vm.competenciesItems,
                          filterField: _vm.competenciesField,
                          action: _vm.changeCompetenciesFilter,
                          inputHeight: 45,
                          labelDisplaySelection: true,
                          label: _vm
                            .$t("stemdoerDetail.experienceModal.competencies")
                            .toString(),
                          tempFilters: false,
                          errorMessage:
                            _vm.vuelidate.competencies.$error &&
                            _vm.vuelidate.competencies.required?.$invalid
                              ? _vm.$t("formMessage.required").toString()
                              : undefined,
                          mode: "chip",
                        },
                        on: {
                          input: (val) =>
                            (_vm.experienceForm.competencies = val),
                          "create-tech": _vm.onCreateTech,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("SInputTextarea", {
                        attrs: {
                          label: _vm
                            .$t("stemdoerDetail.experienceModal.description")
                            .toString(),
                          placeholder: _vm
                            .$t(
                              "stemdoerDetail.experienceModal.descriptionPlaceholder"
                            )
                            .toString(),
                          errorMessage:
                            _vm.vuelidate.description.$error &&
                            _vm.vuelidate.description.required?.$invalid
                              ? _vm.$t("formMessage.required").toString()
                              : undefined,
                        },
                        model: {
                          value: _vm.experienceForm.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.experienceForm, "description", $$v)
                          },
                          expression: "experienceForm.description",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "v-container",
                  { staticClass: "pa-0" },
                  [
                    _c(
                      "v-row",
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "mr-6" },
                          [
                            _vm.experience
                              ? [
                                  _c("SButton", {
                                    attrs: {
                                      action: _vm.onDeleteClick,
                                      btnStyle: "quaternary",
                                      sText: _vm.$t(
                                        "stemdoerDetail.experienceModal.deleteButton"
                                      ),
                                    },
                                  }),
                                ]
                              : [
                                  _c("SButton", {
                                    attrs: {
                                      action: _vm.closeModal,
                                      btnStyle: "tertiary",
                                      sText: _vm.$t(
                                        "stemdoerDetail.experienceModal.cancelButton"
                                      ),
                                    },
                                  }),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          [
                            _c("SButton", {
                              attrs: {
                                action: _vm.onSaveClick,
                                sText: _vm.$t(
                                  "stemdoerDetail.experienceModal.saveButton"
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("ExpDeletedModal", {
        attrs: {
          "data-cy": "exp-deleted-modal",
          isOpen: _vm.isExpDeletedModalOpen,
          onClose: _vm.handleDeleteCancel,
          onSuccess: _vm.handleDeleteConfirm,
          experience: _vm.experience || {},
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }